import React, { ReactElement } from 'react';
import FlexContainer from '../flex-container/flex-container.component';
import GridItem from '../grid-item/grid-item.component';
import useStylesGridItemCardViewLine from './grid-item-card-view-line.styles';

const GridItemCardViewLine: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    headerTitle,
    icon,
    children,
  } = props;

  const { classes } = useStylesGridItemCardViewLine();

  return (
    <GridItem isFullWidth>
      <FlexContainer className={classes.gridItemCardViewLine}>
        {
          !!headerTitle && (
            <FlexContainer className={classes.gridItemCardViewLineHeader}>
              {headerTitle}
              :
            </FlexContainer>
          )
        }
        {
          !!icon && (
            <FlexContainer className={classes.gridItemCardViewLineIcon}>
              {icon}
            </FlexContainer>
          )
        }
        <FlexContainer>
          {children}
        </FlexContainer>
      </FlexContainer>
    </GridItem>
  );
});

export default GridItemCardViewLine;
